document.addEventListener('DOMContentLoaded', function () {
	// Find all placeholder elements with the class .component-opening-hours
	const placeholderDivs = document.querySelectorAll('.component.origo.opening-hours');

	// If no elements are found, stop.
	if (placeholderDivs.length === 0) {
		// console.warn('No elements with class .component-opening-hours found.');
		return;
	}

	// --- Helper function to perform fetch with retries (REMOVED - using window.OrigoApi) ---

	// --- REVISED LOGIC ---

	// 1. Create a Map to group elements by their 'data-hours' key
	const requestsMap = new Map();

	placeholderDivs.forEach(placeholderDiv => {
		const hoursField = placeholderDiv.dataset.hours;

		// If the current element doesn't have the data attribute, skip it
		if (!hoursField) {
			// placeholderDiv.innerHTML = '<p>Er is een configuratiefout gevonden.</p>';
			return; // Move to the next element
		}

		// Check if we already have an entry for this hoursField
		if (!requestsMap.has(hoursField)) {
			// If not, create a new empty array for this key
			requestsMap.set(hoursField, []);
		}

		// Add the current element to the array for its corresponding hoursField
		requestsMap.get(hoursField).push(placeholderDiv);
	});

	// 2. Now, loop over the *unique requests* (the entries in the Map)
	// 'hoursField' is the key (e.g., "123_4")
	// 'elementsToUpdate' is the array of DOM elements that need this data
	requestsMap.forEach((elementsToUpdate, hoursField) => {

		const [entityId, typeId] = hoursField.split('_');

		// Construct the API URL *once* for this group
		const apiUrl = `${origoOpeningHoursConfig.apiUrl}?entity_id=${entityId}&type_id=${typeId}`;

		// Use the shared cached fetch logic
		if (window.OrigoApi && window.OrigoApi.fetchCached) {
			window.OrigoApi.fetchCached(apiUrl)
				.then(data => {
					// Data successfully fetched for this group.
					// Now, loop through all elements that were waiting for this data.
					elementsToUpdate.forEach(placeholderDiv => {

						// Get the *individual* display settings for *this* element
						const showTitle = placeholderDiv.dataset.title;
						const showDescriptionTop = placeholderDiv.dataset.description_top;
						const showDescriptionBottom = placeholderDiv.dataset.description_bottom;

						let contentHtml = ''; // Build the HTML for this specific element

						if (data.days && data.days.length > 0) {
							if (showTitle && data.info.title !== null) {
								contentHtml += `<h3>${data.info.title}</h3>`
							}

							contentHtml += '<table><tbody>';
							data.days.forEach(day => {
								const dayName = day.day_name;
								const dayNumber = day.day_number;
								const monthName = day.month_name;
								const date = dayNumber + ' ' + monthName;
								const openTime = day.open_time ?? null;
								const closeTime = day.close_time ?? null;
								const label = day.label ?? null;
								const text = day.text ?? null;

								contentHtml += '<tr><td>';
								contentHtml += `<strong class="day">${dayName}&nbsp;${label && label.trim() !== '' ? `<span class="label">${label}</span>` : ''}</strong>`;

								if (openTime !== null && closeTime !== null) {
									contentHtml += `${date} van ${openTime} - ${closeTime} uur`;

									if (text && text.trim() !== '') {
										contentHtml += ` ${text}`;
									}
								} else {
									contentHtml += `${date} ` + (text && text.trim() !== '' ? text : 'gesloten');
								}
								contentHtml += '</td></tr>';
							});
							contentHtml += '</tbody></table>';

							if (showDescriptionBottom && data.info.description_bottom !== null) {
								contentHtml += `<br>${data.info.description_bottom}`
							}
						}

						// Update the inner HTML of the current placeholder element
						placeholderDiv.innerHTML = contentHtml;
						delete placeholderDiv.dataset.hours;
						delete placeholderDiv.dataset.shoutout;
						delete placeholderDiv.dataset.title;
						delete placeholderDiv.dataset.description_top;
						delete placeholderDiv.dataset.description_bottom;
					});
				})
				.catch(error => {
					console.log(`Failed to fetch opening hours for ${hoursField}:`, error);
					// Optionally, update all elements in this group with an error message
					elementsToUpdate.forEach(placeholderDiv => {
						placeholderDiv.innerHTML = '<p>Openingstijden konden niet worden geladen.</p>';
					});
				});
		} // Close window.OrigoApi check

	}); // End of requestsMap.forEach loop
});
